module.exports = __webpack_public_path__ + "static/img/study_report_official.fddd0ab9.png";